export const COUPON_HISTORY_SLICE_NAME = 'gygCouponHistory'

export const GET_COUPON_HISTORY_BY_USER_ID_ACTION = `${COUPON_HISTORY_SLICE_NAME}/getCouponHistoryByUserId`
export const ISSUE_COUPON_ACTION = `${COUPON_HISTORY_SLICE_NAME}/issueCoupon`
export const UPDATE_COUPON_STATUS_ACTION = `${COUPON_HISTORY_SLICE_NAME}/updateCouponStatus`
